import { Box, Card } from '@zillow/constellation-10';

import Bone from '../../../Bone';

const CardSkeleton = () => (
  <Card outlined elevated={false} dividers={false} css={{ borderRadius: '300' }}>
    <Box
      css={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '400',
      }}
    >
      <Box css={{ display: 'flex', alignItems: 'center', gap: '400', flex: 1 }}>
        <Box css={{ flexShrink: 0, width: '800', height: '800' }}>
          <Bone type="cover" />
        </Box>
        <Box css={{ display: 'flex', flexDirection: 'column', gap: '200', flex: 1 }}>
          <Box css={{ width: '60%' }}>
            <Bone type="line" />
          </Box>
          <Box css={{ width: '40%' }}>
            <Bone type="line" />
          </Box>
        </Box>
      </Box>
      <Box css={{ flexShrink: 0, width: '120px', height: '800' }}>
        <Bone type="cover" />
      </Box>
    </Box>
  </Card>
);

export default CardSkeleton;
